import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
//import { apiRequest } from "../../utils/api";
import styles from "./index.module.scss";

const OTPInput = ({ handleOtpSubmit, digit = 6, username, handleResendOtp, numberOfAvailalbeTries, verificationAttempted, getNewCode, autoOtp, flow = "login"
}) => {
  const [OTPValue, setOTPValue] = useState(Array(digit).fill(""));
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true); // New state to track resend availability
  const { t } = useTranslation();

  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    }
    else {
      setIsResendDisabled(false); // Enable resend after 60 seconds
    }
  }, [timer]);

  const handleChange = (index, event) => {
    const rawValue = event.target.value;

    // Only allow single alphanumeric characters
    const sanitized = rawValue.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 1);

    const updatedOtp = [...OTPValue];
    updatedOtp[index] = sanitized;
    setOTPValue(updatedOtp);
  };


  const handleInputNavigation = (event) => {
    const { key } = event;
    const input = event.target;
    const form = input.form;
    const index = input.tabIndex;

    if ((key === "Backspace" || key === "Delete") && input.value === "") {
      const prev = form?.elements[index - 1];
      if (prev) prev.focus();
    } else if (/^[a-zA-Z0-9]$/.test(key) && input.value) {
      const next = form?.elements[index + 1];
      if (next) next.focus();
    }
  };

  const resendOtp = async () => {
  if (isResendDisabled) return;

  try {
    await getNewCode(); 
    setTimer(60);
    setIsResendDisabled(true);
  } catch (error) {
    console.error("Error while resending OTP:", error);
  }
};

  const isOtpComplete = OTPValue.every(val => val.trim() !== "");

  const handlePaste = (event) => {
    event.preventDefault();
    const paste = (event.clipboardData || window.clipboardData).getData("text");
    const newOtp = [...OTPValue];

    for (let i = 0; i < digit; i++) {
      newOtp[i] = paste[i] || "";
    }
    setOTPValue(newOtp)
  }

  useEffect(() => {
    if (autoOtp) {
      const newOtp = [...OTPValue];
      for (let i = 0; i < digit; i++) {
        newOtp[i] = autoOtp[i] || "";
      }
      setOTPValue(newOtp)
    }
  }, [autoOtp])



  return (
    <div className={styles.otpContainer}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleOtpSubmit(OTPValue.join(""));
        }}>

        {flow === "login" ? (
          <p className={styles.OTPHeader}>
            {t("login.emailCode")}
            <a href="/guide.pdf" download className={styles.downloadLink}>{t("login.checkGuide")}</a>
          </p>
        ) : (
          <>
            <p className={styles.OTPHeader2fa}>{t("login.otpResetCode")}</p>
            <p className={styles.OTPHeader}>{t("login.otpResetCodeHint")}</p>
          </>
        )}

        {numberOfAvailalbeTries < 10 && verificationAttempted ? (
          <div className={styles.errorBox}>
            <div className={styles.iconWrapper}>
              <NotificationImportantIcon style={{ color: '#EA1D25', fontSize: 24 }} />
            </div>
            <div className={styles.errorContent}>
              <p className={styles.errorText}>
                <Trans i18nKey="login.otpError" values={{ count: numberOfAvailalbeTries }} components={{ strong: <strong /> }} />
              </p>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={styles.inputWrapper} onPaste={handlePaste}>
          {OTPValue.map((elem, index) => (
            <input
              key={index}
              name={`otp${index}`}
              type="text"
              autoComplete="off"
              className={`${styles.otpInput} ${numberOfAvailalbeTries < 10 ? styles.otpInputError : ""
                }`}
              value={elem}
              onChange={e => handleChange(index, e)}
              tabIndex={index}
              maxLength="1"
              onKeyDown={handleInputNavigation}
            />
          ))}
        </div>

        <div className={styles.resendWrapper}>
          {flow === "login" ? (
            <>
              {t("login.noCode")}{" "}
              {timer > 0 ? (
                <span
                  className={styles.timerText}
                  style={{ cursor: 'not-allowed', color: '#a1a1a1' }} // Make it visually disabled
                >
                  {t("login.newCodeIn")} ({timer}s)
                </span>
              ) : (
                <span
                  className={styles.resendLink}
                  onClick={resendOtp}
                  style={{
                    color: isResendDisabled ? '#a1a1a1' : '#f5b019', // Disabled color until timer finishes
                    cursor: isResendDisabled ? 'not-allowed' : 'pointer' // Disabled cursor
                  }}
                >
                  {t("login.newCode")}
                </span>
              )}
            </>
          ) : (
            <>
              {timer > 0 ? (
                <span style={{ color: '#a1a1a1' }}>
                  {t("login.otpResetNoCode")} {t("login.otpResetNewCodeIn")} ({timer}s)
                </span>
              ) : (
                <span>
                  {t("login.otpResetCodeExpired")}{" "}
                  <span
                    className={styles.resendLink}
                    onClick={resendOtp}
                    style={{
                      color: '#f5b019',
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                  >
                    {t("login.otpResetRequestCode")}
                  </span>
                </span>
              )}
            </>
          )}
        </div>

        <button
          type="submit"
          className={`${styles.verifyButton} ${!isOtpComplete ? styles.disabled : ""}`}
          disabled={!isOtpComplete}
        >
          {t("login.verifyEmail")}
        </button>
      </form>
    </div>
  );
};

export default OTPInput;